import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useTextosDaLoja } from '@/construtor/textos';
import { Caixa } from '@/construtor/caixa';

export function PaymentFailure() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTextosDaLoja();

  const paymentId = searchParams.get('payment_id');
  const statusDetail = searchParams.get('status_detail');

  const getErrorMessage = () => {
    switch (statusDetail) {
      case 'cc_rejected_insufficient_amount':
        return t('payment.failure.insufficient_amount');
      case 'cc_rejected_bad_filled_security_code':
        return t('payment.failure.bad_security_code');
      case 'cc_rejected_bad_filled_date':
        return t('payment.failure.bad_date');
      case 'cc_rejected_bad_filled_other':
        return t('payment.failure.bad_other');
      default:
        return t('payment.failure.desc');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <Caixa id="pagamento.recusado.cartao" miolo>
      <Card className="max-w-md w-full">
        <CardContent className="pt-6 text-center space-y-4">
          <Caixa id="pagamento.recusado.icone">
          <div className="flex justify-center">
            <XCircle className="w-16 h-16 text-destructive" />
          </div>
          </Caixa>

          <Caixa id="pagamento.recusado.titulo">
          <h1 className="text-2xl font-bold text-foreground">
            {t('payment.failure.title')}
          </h1>
          </Caixa>

          <Caixa id="pagamento.recusado.mensagem">
          <p className="text-muted-foreground">
            {getErrorMessage()}
          </p>
          </Caixa>

          {paymentId && (
            <Caixa id="pagamento.recusado.referencia">
            <div className="bg-muted p-3 rounded-lg text-sm">
              <p className="text-muted-foreground">{t('payment.failure.reference')}</p>
              <p className="font-mono font-semibold">{paymentId}</p>
            </div>
            </Caixa>
          )}

          <Caixa id="pagamento.recusado.botoes">
          <div className="space-y-2 pt-4">
            <Button 
              onClick={() => navigate('/carrinho')} 
              className="w-full"
            >
              {t('payment.failure.retry')}
            </Button>
            <Button 
              onClick={() => navigate('/')} 
              variant="outline"
              className="w-full"
            >
              {t('payment.failure.back_to_store')}
            </Button>
          </div>
          </Caixa>
        </CardContent>
      </Card>
      </Caixa>
    </div>
  );
}
